import { FC, useMemo, useState } from 'react';
import { app } from '../../../../@xmcloud/core/messages/en';
import { pageSize } from '../../../../@xmcloud/utils/constants';
import {
	AbstractGetClientResponse,
	GetOrganizationClientResponse,
} from '../../../models/clientModel';
import { useGetOrganizationClientList } from '../../../services/clients';
import {
	LoadingSkeleton,
	RenderPlaceholder,
	Table,
} from '../../../shared-components';
import { organizationCredentialsTableColumns } from '../columns/organizations';
import RevokeClientConfirmation from './RevokeClientConfirmation';
import { ColumnDef } from '@tanstack/react-table';

const headers = ['name', 'Description', 'Client ID', 'Date created', ''];

const OrganizationCredentialsTable: FC = () => {
	const [showClientRevokeModal, setShowClientRevokeModal] = useState(false);
	const [selectedClient, setSelectedClient] = useState(
		{} as AbstractGetClientResponse,
	);

	const { data, isLoading } = useGetOrganizationClientList();
	const clients = data?.data?.items || [];

	const columns: ColumnDef<GetOrganizationClientResponse, any>[] =
		useMemo(() => {
			return organizationCredentialsTableColumns(
				setSelectedClient,
				setShowClientRevokeModal,
			);
		}, []);

	if (isLoading) return <LoadingSkeleton amount={pageSize + 1} />;
	if (clients.length === 0)
		return <RenderPlaceholder item={app.credentials.toLocaleLowerCase()} />;

	return (
		<>
			<Table
				{...{
					columns,
					tableData: clients,
					dataTestId: 'credentials-organization-table',
					showPagination: clients.length > pageSize,
					initialSort: [{ id: 'createdAt', desc: true }],
					headers,
				}}
			/>
			{showClientRevokeModal && (
				<RevokeClientConfirmation
					client={selectedClient}
					openModal={showClientRevokeModal}
					setOpenModal={setShowClientRevokeModal}
				/>
			)}
		</>
	);
};

export default OrganizationCredentialsTable;
